/** Values the fixtures API (`/fixture/groupByCompetition?sport=`) accepts; anything else is a 400. */
export type FixtureSport =
  | 'Cricket'
  | 'Football'
  | 'Tennis'
  | 'Greyhound'
  | 'HorseRacing'
  | 'Basketball'
  | 'Soccer'
  | 'Other';

export type SportItem = {
  label: string;
  /** Sport name as the API and `/all-sports/:sportName` route expect it */
  apiName: string;
  /** Name for the fixtures API's `sport` filter; unset when that API doesn't list this sport. */
  fixtureSport?: FixtureSport;
  disabled?: boolean;
};

export const SPORTS: SportItem[] = [
  { label: 'Cricket', apiName: 'Cricket', fixtureSport: 'Cricket' },
  { label: 'Football', apiName: 'Soccer', fixtureSport: 'Soccer' },
  { label: 'Tennis', apiName: 'Tennis', fixtureSport: 'Tennis' },
  { label: 'Kabaddi', apiName: 'Kabaddi' },
  { label: 'Politics', apiName: 'Politics' },
  { label: 'Basketball', apiName: 'Basketball', fixtureSport: 'Basketball' },
  { label: 'Baseball', apiName: 'Baseball' },
  { label: 'Table Tennis', apiName: 'Table Tennis' },
  { label: 'Volleyball', apiName: 'Volleyball' },
  { label: 'Ice Hockey', apiName: 'Ice Hockey' },
  { label: 'Rugby', apiName: 'Rugby Union' },
  { label: 'Mixed Martial Arts', apiName: 'Mixed Martial Arts' },
  { label: 'Darts', apiName: 'Darts' },
  { label: 'Futsal', apiName: 'Futsal' },
  { label: 'Horse Racing', apiName: 'Horse Racing', fixtureSport: 'HorseRacing' },
  { label: 'Greyhound Racing', apiName: 'Greyhound Racing', fixtureSport: 'Greyhound' },
];

/** The fixtures API `sport` value for a route sport name, or undefined if that API has none. */
export const getFixtureSport = (apiName?: string) =>
  SPORTS.find((sport) => sport.apiName.toLowerCase() === apiName?.toLowerCase())?.fixtureSport;

export const getSportLabel = (apiName?: string) =>
  SPORTS.find((sport) => sport.apiName.toLowerCase() === apiName?.toLowerCase())?.label ?? apiName;
